import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { useEffect, useRef, useState } from 'react';
import { obtenerConfigByCabCodigo } from '../../services/Configuracion/ConfiguracionDetService';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { FileUpload } from 'primereact/fileupload';
import CapturaFotosEmpleado from './CapturaFotosEmpleado';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { formatToJava } from '../../util/dateUtils';
import {
    actualizaDotacion,
    crearDotacion,
    guardarDocumentoDotacion
} from '../../services/empleado/EmpleadoDotacionService';
import CreaDet from '../ConfiguraDet/CreaDet';
import { creaNuevoDet, modificaDet } from '../../services/Roles/RolesService';

const DotacionForm = ({
    listaGrupo,
    listaEstado,
    listaEntrega,
    listaDevolucion,
    datosDotacion,
    empleadoId,
    funcCerrar,
    tipoRegistroDoc
}) => {

    const [lstItemDotacion, setLstItemDotacion] = useState([]);
    const [itemDotacion, setItemDotacion] = useState({});
    const [cargaLstItem, setCargaLstItem] = useState(false);
    const [itemGrupo, setItemGrupo] = useState({});
    const [visibleAdiItem, setVisibleAdiItem] = useState(false);
    const [itemEdit, setItemEdit] = useState({});
    const [recargaItem, setRecargaItem] = useState(false);

    const [cantidad, setCantidad] = useState("");
    const [comentario, setComentario] = useState('');
    const [fechaEntrega, setFechaEntrega] = useState();
    const [estadoEntrega, setEstadoEntrega] = useState({});
    const [fechaDevolucion, setFechaDevolucion] = useState();
    const [estadoDevolucion, setEstadoDevolucion] = useState({});

    const [estado, setEstado] = useState({});
    const [lstImagenes, setLstImagenes] = useState([]);
    const [lstFotos, setLstFotos] = useState([]);
    const [lstImagenesDev, setLstImagenesDev] = useState([]);
    const [lstFotosDev, setLstFotosDev] = useState([]);
    const [ctrlDisable, setCtrlDisable] = useState(false);

    const [procesa, setProcesa] = useState(false);

    const myToast = useRef();

    useEffect(() => {
        const poneDatos = () => {
            if (datosDotacion?.dotacionId) {
                // hay que actualizar
                const grupoSel = listaGrupo.find(
                    (item) => item.configuracionCabId === datosDotacion.grupoDotacionConfId
                );
                if (grupoSel) {
                    setItemGrupo(grupoSel);
                }
                const itemSel = {
                    nombre: datosDotacion.tipoDotacionNombre,
                    configuracionDetId: datosDotacion.tipoDotacionConfId
                };
                setItemDotacion(itemSel);
                const estadoSel = listaEstado.find(
                    (item) => item.configuracionDetId === datosDotacion.estadoConfId
                );
                if (estadoSel) setEstado(estadoSel);
                setCantidad(datosDotacion.cantidad);
                setFechaEntrega(datosDotacion.fechaEntrega);
                const estEntrega = listaEntrega.find(
                    (item) => item.configuracionDetId === datosDotacion.estadoDotacionConfId
                );
                if (estEntrega) setEstadoEntrega(estEntrega);
                setComentario(datosDotacion.comentario);
                setFechaDevolucion(datosDotacion.fechaDevolucion);
                const estDevolucion = listaDevolucion.find(
                    (item) =>
                        item.configuracionDetId === datosDotacion.estadoDotacionDevolucionConfId
                );
                if (estDevolucion) setEstadoDevolucion(estDevolucion);
            } else {
                // hay que Crear
                const estadoActivo = listaEstado.find((item) =>
                    item.nombre.toUpperCase().includes('ACTIVO')
                );
                if (estadoActivo) {
                    setEstado(estadoActivo);
                }
                setCtrlDisable(true);
            }
        };
        poneDatos();
    }, []);

    useEffect(() => {
        const recuperaItemsGrupo = async () => {
            if (itemGrupo?.codigo) {
                try {
                    setCargaLstItem(true);
                    const data = await obtenerConfigByCabCodigo(itemGrupo.codigo);
                    setLstItemDotacion(data);
                } catch (err) {
                    console.error('ERROR: ', err.message);
                } finally {
                    setCargaLstItem(false);
                }
            } else {
                setLstItemDotacion([]);
            }
        };
        recuperaItemsGrupo();
    }, [itemGrupo, recargaItem]);

    const abreAdiItem = () => {
        if (!itemGrupo?.configuracionCabId) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Seleccione primero una Categoría'
            });
            return;
        }
        setItemEdit({});
        setVisibleAdiItem(true);
    };

    const editaItem = () => {
        if (!itemGrupo?.configuracionCabId) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Seleccione primero una Categoría'
            });
            return;
        }
        if (!itemDotacion?.configuracionDetId) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Seleccione un Item para editar'
            });
            return;
        }
        setItemEdit(itemDotacion);
        setVisibleAdiItem(true);
    };

    const valueTemplateConTooltip = (option, props) => {
        if (option) {
            return (
                <span
                    title={option.nombre}
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'block'
                    }}
                >
                    {option.nombre}
                </span>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    const itemTemplateLargo = (option) => (
        <div title={option.nombre} style={{ whiteSpace: 'normal' }}>
            {option.nombre}
        </div>
    );

    const guardaNuevoItem = async (formData) => {
        try {
            if (formData.detalleId === 0) {
                const objPost = {
                    padreConfiguracionDetId: 0,
                    configuracionCabId: itemGrupo.configuracionCabId,
                    codigo: formData.codigo,
                    nombre: formData.nombre,
                    parametro: formData.parametro,
                    estado: 'Activo',
                    activo: formData.activo
                };
                await creaNuevoDet(objPost);
                myToast.current.show({
                    severity: 'success',
                    summary: 'Éxito',
                    detail: 'Item creado correctamente'
                });
            } else {
                const objPost = {
                    configuracionDetId: formData.detalleId,
                    padreConfiguracionDetId: 0,
                    configuracionCabId: itemGrupo.configuracionCabId,
                    codigo: formData.codigo,
                    nombre: formData.nombre,
                    parametro: formData.parametro,
                    estado: 'Activo',
                    activo: formData.activo
                };
                await modificaDet(objPost);
                myToast.current.show({
                    severity: 'success',
                    summary: 'Éxito',
                    detail: 'Item actualizado correctamente'
                });
            }
            setRecargaItem((prev) => !prev);
        } catch (err) {
            console.error('Error guardando Item: ', err.message);
            myToast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo guardar el Item'
            });
        } finally {
            setVisibleAdiItem(false);
        }
    };

    const fotosUploadEntrega = (evt) => {
        setLstImagenes((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, ...evt.files];
        });
    };
    const fotosCamaraEntrega = (fotoCamara) => {
        setLstFotos((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, fotoCamara];
        });
    };

    const fotosUploadDev = (evt) => {
        setLstImagenesDev((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, ...evt.files];
        });
    };
    const fotosCamaraDev = (fotoCamara) => {
        setLstFotosDev((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, fotoCamara];
        });
    };

    const pausa = (ms) => new Promise((res) => setTimeout(res, ms));

    const handleGuardar = async () => {
        if (!itemGrupo?.configuracionCabId) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe seleccionar un Grupo'
            });
            return;
        }
        if (!itemDotacion?.configuracionDetId) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe seleccionar un Item de Dotacion'
            });
            return;
        }
        if (!cantidad && cantidad === 0) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar la Cantidad'
            });
            return;
        }
        if (!fechaEntrega) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar Fecha de Entrega'
            });
            return;
        }
        if (!estadoEntrega?.configuracionDetId) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar Estado de Entrega'
            });
            return;
        }
        if (!datosDotacion?.dotacionId && lstImagenes.length + lstFotos.length === 0) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe seleccionar al menos una Foto/Imagen'
            });
            return;
        }

        const allImagenesEntrega = [...lstImagenes, ...lstFotos];
        const allImagenesDev = [...lstImagenesDev, ...lstFotosDev];

        const objPostDotacion = {
            empleadoId: empleadoId,
            grupoDotacionCabId: itemGrupo.configuracionCabId,
            tipoDotacionDetId: itemDotacion.configuracionDetId,
            cantidad: cantidad,
            fechaEntrega: formatToJava(fechaEntrega),
            comentario: comentario,
            estadoConfigDetId: estado.configuracionDetId,
            estadoDotacionConfigDetId: estadoEntrega.configuracionDetId
        };

        let dotacion;
        setProcesa(true);
        if (datosDotacion?.dotacionId) {
            // edicion se adicionan los datos
            objPostDotacion['dotacionId'] = datosDotacion?.dotacionId;
            objPostDotacion['fechaDevolucion'] = formatToJava(fechaDevolucion)
            objPostDotacion['estadoDotacionDevueltoConfigDetId'] = estadoDevolucion.configuracionDetId
            try {
                dotacion = await actualizaDotacion(objPostDotacion)
                myToast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se han actualizado datos de la Dotacion'
                });
            } catch (err) {
                console.error('ERROR: ', err.message);
            }
        } else {
            // creacion
            try {
                dotacion = await crearDotacion(objPostDotacion);
                myToast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se ha creado la Dotacion'
                });
                //await pausa(1000);
                //funcCerrar()
            } catch (err) {
                console.error('ERROR: ', err.message);
            } finally {
                //setProcesa(false);
            }
        }
        if (dotacion?.dotacionId) {
            const formData = new FormData();

            formData.append('entidadId', empleadoId);
            formData.append('tipoRegistroId', dotacion.dotacionId);
            formData.append('nombreEntidad', 'EMPLEADO');
            formData.append('tipoRegistroConfDetId', tipoRegistroDoc.configuracionDetId);
            formData.append('categoriaConfDetId', itemDotacion.configuracionDetId);
            formData.append('referenciaDetalle', 'DOTACION_ID ' + dotacion.dotacionId);
            formData.append('descripcion', 'ENTREGA');
            formData.append('codigoTipoDocumento', tipoRegistroDoc.codigo);
            formData.append('fechaEmision', formatToJava(fechaEntrega));

            if (allImagenesEntrega.length !== 0) {
                // intentando guardar las imagenes ENTREGA
                allImagenesEntrega.forEach((file) => {
                    formData.append('archivos', file, file.name);
                });

                try {
                    //console.log('MIS DATOS..', formData)
                    const response = await guardarDocumentoDotacion(formData);
                    myToast.current.show({
                        severity: 'success',
                        summary: 'Exito',
                        detail: 'Se han registrado las imagenes'
                    });
                } catch (error) {
                    console.error('ERROR: ', error.message);
                    myToast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Error al registrar las imagenes'
                    });
                } finally {
                    //await pausa(1000);
                    //funcCerrar();
                    //setProcesa(false);
                }
            }
            if (allImagenesDev.length !== 0) {
                // intenta guardar los datos de DEVOLUCION
                if (formData.has('descripcion')) formData.delete('descripcion');
                if (formData.has('archivos')) formData.delete('archivos');
                if (formData.has('fechaEmision')) formData.delete('fechaEmision');

                formData.append('descripcion', 'DEVOLUCION');
                formData.append('fechaEmision', formatToJava(fechaDevolucion));
                allImagenesDev.forEach((file) => {
                    formData.append('archivos', file, file.name);
                });
                try {
                    const response = await guardarDocumentoDotacion(formData);
                    myToast.current.show({
                        severity: 'success',
                        summary: 'Exito',
                        detail: 'Se han registrado las imagenes'
                    });
                } catch (error) {
                    console.error('ERROR: ', error.message);
                    myToast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Error al registrar las imagenes'
                    });
                } 
            }
        }
        await pausa(1000);
        setProcesa(false);
        funcCerrar();
    };

    return (
        <div className="p-fluid formgrid grid">
            <Toast ref={myToast} />
            {/* GRUPOS */}
            <div className="field col-12 md:col-6">
                <label>Categoría:</label>
                <div className="p-inputgroup">
                    <Dropdown
                        options={listaGrupo}
                        value={itemGrupo}
                        optionLabel="nombre"
                        placeholder="Seleccione"
                        dataKey="configuracionCabId"
                        onChange={(evt) => setItemGrupo(evt.value)}
                        showClear
                        valueTemplate={valueTemplateConTooltip}
                        itemTemplate={itemTemplateLargo}
                    />
                    <Button icon="pi pi-plus" className="p-button-success" disabled />
                </div>
            </div>
            {/* ITEM DE DOTACION */}
            <div className="field col-12 md:col-6">
                <label>Item:</label>
                <div className="p-inputgroup">
                    {cargaLstItem ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner
                                style={{ width: '20px', height: '20px' }}
                                strokeWidth="8"
                            />
                        </div>
                    ) : (
                        <Dropdown
                            options={lstItemDotacion}
                            value={itemDotacion}
                            optionLabel="nombre"
                            dataKey="configuracionDetId"
                            placeholder="Seleccione Item"
                            onChange={(evt) => setItemDotacion(evt.value)}
                            showClear
                            filter
                            valueTemplate={valueTemplateConTooltip}
                            itemTemplate={itemTemplateLargo}
                        />
                    )}
                    <Button
                        icon="pi pi-plus"
                        className="p-button-success"
                        onClick={abreAdiItem}
                        tooltip="Agregar nuevo Item"
                        disabled={!itemGrupo?.configuracionCabId}
                    />
                    <Button
                        icon="pi pi-pencil"
                        className="p-button-info"
                        onClick={editaItem}
                        tooltip="Editar Item seleccionado"
                        disabled={!itemDotacion?.configuracionDetId}
                    />
                </div>
            </div>
            <Dialog
                visible={visibleAdiItem}
                onHide={() => setVisibleAdiItem(false)}
                header={itemEdit?.configuracionDetId ? 'Editar Item' : 'Nuevo Item'}
                style={{ width: '40vw' }}
            >
                <CreaDet
                    cabecera={itemGrupo}
                    onGuardar={guardaNuevoItem}
                    detalle={itemEdit}
                />
            </Dialog>
            {/* ESTADO DOTACION */}
            <div className="field col-12 md:col-6">
                <label>Estado Dotacion:</label>
                <Dropdown
                    options={listaEstado}
                    value={estado}
                    optionLabel="nombre"
                    placeholder="Seleccionar Estado"
                    onChange={(evt) => setEstado(evt.value)}
                    dataKey="configuracionDetId"
                    disabled={ctrlDisable}
                />
            </div>
            {/* CANTIDAD */}
            <div className="field col-12 md:col-6">
                <label>Cantidad:</label>
                <InputText
                    value={cantidad}
                    keyfilter="num"
                    onChange={(evt) => setCantidad(evt.target.value)}
                />
            </div>
            {/* FECHA ENTREGA */}
            <div className="field col-12 md:col-6">
                <label>Fecha Entrega:</label>
                <Calendar
                    showIcon
                    dateFormat="dd/mm/yy"
                    value={fechaEntrega}
                    onChange={(evt) => setFechaEntrega(evt.value)}
                />
            </div>
            <div className="field col-12 md:col-6">
                <label>Estado de Entrega:</label>
                <Dropdown
                    options={listaEntrega}
                    value={estadoEntrega}
                    optionLabel="nombre"
                    dataKey="configuracionDetId"
                    placeholder="Seleccionar Estado de Entrega"
                    onChange={(evt) => setEstadoEntrega(evt.value)}
                    showClear
                />
            </div>
            <div className="field col-12 md:col-6">
                <FileUpload
                    mode="basic"
                    name="archivos"
                    auto={false}
                    chooseLabel="Adjuntar archivo"
                    className="p-button-info w-auto"
                    onSelect={fotosUploadEntrega}
                    multiple={true}
                    accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
                />
                {lstImagenes.length !== 0 && (
                    <span className="text-sm font-light text-slate-500 italic tracking-wide">
                        Imagenes Seleccionadas: {lstImagenes.length}{' '}
                    </span>
                )}
            </div>
            <div className="field col-12 md:col-6">
                <CapturaFotosEmpleado funcFoto={fotosCamaraEntrega} />
                {lstFotos.length !== 0 && (
                    <span className="text-sm font-light text-slate-500 italic tracking-wide">
                        Imagenes de Camara: {lstFotos.length}{' '}
                    </span>
                )}
            </div>

            <div className="field col-12 md:col-12">
                <label>Comentario:</label>
                <InputText value={comentario} onChange={(evt) => setComentario(evt.target.value)} />
            </div>
            <div className="field col-12 md:col-12">
                <Divider align="left">
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-user mr-2"></i>
                        <b>Devolución</b>
                    </div>
                </Divider>
            </div>
            <div className="field col-12 md:col-6">
                <label>Fecha Devolucion:</label>
                <Calendar showIcon dateFormat="dd/mm/yy" disabled={ctrlDisable} value={fechaDevolucion}
                    onChange={(evt) => setFechaDevolucion(evt.value)}/>
            </div>
            <div className="field col-12 md:col-6">
                <label>Estado de Devolucion:</label>
                <Dropdown
                    options={listaDevolucion}
                    value={estadoDevolucion}
                    optionLabel="nombre"
                    dataKey="configuracionDetId"
                    placeholder="Seleccionar Estado de Entrega"
                    onChange={(evt) => setEstadoDevolucion(evt.value)}
                    disabled={ctrlDisable}
                />
            </div>
            <div className="field col-12 md:col-6">
                <FileUpload
                    mode="basic"
                    name="archivos"
                    auto={false}
                    chooseLabel="Adjuntar evidencia"
                    className="p-button-info w-auto"
                    onSelect={fotosUploadDev}
                    onClear={() => setLstImagenes(null)}
                    multiple={true}
                    accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
                    disabled={ctrlDisable}
                />
                {lstImagenesDev.length !== 0 && (
                    <span className="text-sm font-light text-slate-500 italic tracking-wide">
                        Imagenes Seleccionadas: {lstImagenesDev.length}{' '}
                    </span>
                )}
            </div>
            <div className="field col-12 md:col-6">
                {ctrlDisable ? (
                    <label style={{ visibility: 'hidden' }}>Este texto no se ve</label>
                ) : (
                    <CapturaFotosEmpleado funcFoto={fotosCamaraDev} />
                )}
                {lstFotosDev.length !== 0 && (
                    <span className="text-sm font-light text-slate-500 italic tracking-wide">
                        Imagenes de Camara: {lstFotosDev.length}{' '}
                    </span>
                )}
            </div>
            <div className="field col-12 md:col-6">
                <label style={{ visibility: 'hidden' }}>Este texto no se ve</label>
            </div>
            <div className="field col-12 md:col-6">
                <Button label="Guardar" onClick={handleGuardar} loading={procesa} />
            </div>
        </div>
    );
};

export default DotacionForm;
